export default "__VITE_ASSET__CsDi6pVU__"